var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.className, _vm.fluid ? 'container-fluid' : (_vm.full ? 'container-full' : 'container'), _vm.background && 'container--background-' + _vm.background]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }